import React from "react";
import { Card, CardContent, Typography, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCountUp } from "../../hooks/useCountUp";
import styles from "./Dashboard.module.scss";

const ICON_VARIANT_MAP = {
  Leads: "iconLeads",
  Conversions: "iconConversions",
  "Pending Payments": "iconPendingPayments",
  Revenue: "iconRevenue",
  "Cash collected": "iconRevenue",
  "Conversion Rate": "iconConversionRate",
  "Period conversion rate": "iconPeriodConversionRate",
};

export default function MetricCard({
  label,
  value,
  icon,
  color = "#5e72e4",
  to,
  onClick,
  countUp = true,
  tooltip,
}) {
  const navigate = useNavigate();
  const animated = useCountUp(value, { duration: 800 });
  const displayValue = countUp ? animated : value != null ? String(value) : "";
  const iconVariant = ICON_VARIANT_MAP[label] || "";

  const handleClick = () => {
    if (to) navigate(to);
    if (onClick) onClick();
  };

  const card = (
    <Card
      className={styles.metricCard}
      sx={{
        borderRadius: 2,
        background: "var(--bg-card, #fff)",
        border: "1px solid var(--border-color, #e5e7eb)",
        cursor: to || onClick ? "pointer" : "default",
        height: "100%",
      }}
      onClick={handleClick}
    >
      <CardContent sx={{ p: 1.75, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <Typography
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: "clamp(0.875rem, 2.8vw, 1.5rem)",
            lineHeight: 1.2,
            color: "var(--text-primary, #1f2937)",
            mb: 1,
            minHeight: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {displayValue}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          {icon && (
            <Box
              className={`${styles.metricCardIconWrap} ${iconVariant ? styles[iconVariant] : ""}`}
              sx={!iconVariant ? { bgcolor: color } : {}}
            >
              {React.cloneElement(icon, { sx: { fontSize: 20, ...icon.props?.sx } })}
            </Box>
          )}
          <Typography variant="body2" color="text.secondary" fontWeight={600} sx={{ fontSize: "clamp(0.65rem, 1.5vw, 0.75rem)", lineHeight: 1.2 }}>
            {label}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  if (!tooltip) return card;

  return (
    <Tooltip title={tooltip} arrow placement="top" enterDelay={300}>
      <Box sx={{ height: "100%", display: "block" }}>{card}</Box>
    </Tooltip>
  );
}
